<template>
  <div
    id="sow-view-content"
    class="sow-view-containter"
  >
    <ul
      :id="sowAccordionId"
      class="accordion"
      data-accordion
      data-deep-link="true"
      data-allow-all-closed="true"
      data-multi-expand="true"
      data-update-history="true"
      data-deep-link-smudge="500"
    >
      <li
        class="accordion-item is-active"
        data-accordion-item
      >
        <a class="accordion-title">{{ $t('tender.sow.generalDesc') }}</a>
        <div
          id="deeplink1"
          class="accordion-content email-preview"
          data-tab-content
        >
          <div
            class="email-preview__content"
            :class="highlightAddendumChange('generalDesc')"
            v-html="scopeOfWorks.generalDesc"
          />
        </div>
      </li>
      <li
        class="accordion-item is-active"
        data-accordion-item
      >
        <a class="accordion-title">{{ $t('tender.sow.generalSpec') }}</a>
        <div
          id="deeplink2"
          class="accordion-content email-preview"
          data-tab-content
        >
          <div
            class="email-preview__content"
            :class="highlightAddendumChange('generalSpec')"
            v-html="scopeOfWorks.generalSpec"
          />
        </div>
      </li>
      <li
        class="accordion-item is-active"
        data-accordion-item
      >
        <a class="accordion-title">{{ $t('tender.sow.partiSpec') }}</a>
        <div
          id="deeplink3"
          class="accordion-content email-preview"
          data-tab-content
        >
          <div
            class="email-preview__content"
            :class="highlightAddendumChange('particularDesc')"
            v-html="scopeOfWorks.particularDesc"
          />
        </div>
      </li>
      <li
        class="accordion-item is-active"
        data-accordion-item
      >
        <a class="accordion-title">{{ $t('tender.sow.techSpec') }}</a>
        <div
          id="deeplink4"
          class="accordion-content email-preview"
          data-tab-content
        >
          <div
            class="email-preview__content"
            :class="highlightAddendumChange('technicalDesc')"
            v-html="scopeOfWorks.technicalDesc"
          />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { addendumChangeType } from '@/utils/locale'
import { getRandomIdSuffix } from '@/utils/vueCompHelper'

export default {
  name: 'ViewScopeOfWork',
  data () {
    return {
      accordion: null,
      sowAccordionId: `sow-accordion-${getRandomIdSuffix()}`,
    }
  },
  computed: {
    ...mapGetters('tenders', {
      currentTender: 'currentTender',
    }),
    ...mapState('tenders', {
      addendumClassName (state) {
        return state.addendumClassName
      },

      revisionHistory (state) {
        return state.recentRevisionHistory
      },

    }),

    scopeOfWorks () {
      const rec = {
        generalDesc: '<p style="opacity: 0.3;font-family: Verdana;color: #0C3A58;">Nil</p>',
        generalSpec: '<p style="opacity: 0.3;font-family: Verdana;color: #0C3A58;">Nil</p>',
        particularDesc: '<p style="opacity: 0.3;font-family: Verdana;color: #0C3A58;">Nil</p>',
        technicalDesc: '<p style="opacity: 0.3;font-family: Verdana;color: #0C3A58;">Nil</p>',
        ...this.currentTender.general.scopeOfWorks,
      }
      deep(this.currentTender, 'general.id') || setTimeout(this.initAccordion, 2000)
      return rec
    },
  },
  mounted () {
    this.initAccordion()
  },
  destroyed () {
    if (this.accordion) {
      this.accordion.destroy()
    }
  },
  methods: {
    initAccordion () {
      if (this.accordion && Object.keys(this.accordion).length > 0) {
        if ($(`#${this.sowAccordionId}`).childElementCount > 0) {
          this.accordion.destroy()
        }
        delete this.accordion
      }
      if (!this.accordion) {
        this.accordion = new Foundation.Accordion(($(`#${this.sowAccordionId}`)))
      }
    },
    highlightAddendumChange (fieldName) {
      if (Object.keys(this.revisionHistory).length === 0 ||
        !this.revisionHistory.scopeOfWorks) return ''
      return (this.revisionHistory.scopeOfWorks[fieldName])
        ? `${this.addendumClassName}-${addendumChangeType.updated}` : ''
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/accordion';
@import '~styles/tender/addendum';
@import '~styles/email_preview';
.sow-view-containter {
  .accordion-title {
    font-size: 20px;
  }
}
</style>
